// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"dfe5f772","977":"c9147053"}[chunkId] + ".chunk.js";
};